module.exports = __webpack_public_path__ + "static/carousel-iphone16-10cde35ff419ef781ef719e97caae4b7.jpg";